import React from 'react'
import './about.css'
import ME from '../../assets/moi.jpg.png'
import { FaAward } from 'react-icons/fa'
import { FiUsers } from 'react-icons/fi'
import { VscFolderLibrary } from 'react-icons/vsc'

const About = () => {
  return (
    <section id='about'>
      <h5 className='about_title'>Apprendre à me connaitre</h5>
      <h2>A propos de moi</h2>
      <div className='container  about_container'>
        <div className='about_me'>
          <div className='about_me-image'>
            <img src={ME} alt='About me' />
          </div>
        </div>

        <div className='about_content'>
          <div className='about_cards'>
            <article className='about_card'>
              <FaAward className='about_icon'></FaAward>
              <h5>Experiences</h5>
              <small>2+ d'années d'expériences</small>
            </article>

            <article className='about_card'>
              <FiUsers className='about_icon'></FiUsers>
              <h5>Clients</h5>
              <small>50+ de Clients</small>
            </article>

            <article className='about_card'>
              <VscFolderLibrary className='about_icon'></VscFolderLibrary>
              <h5>Projets</h5>
              <small>10+ de projets réalisés</small>
            </article>
          </div>
          <p>
            Ingenieur informaticien et passionné de la programmation, bref de la
            technologie, aptitude de vite apprendre et de m’adapter à n’importe
            quelle technologie.J’ai participé à la réalisation de beaucoup de
            projets académiques telsque: la réalisation d’un site de gestion des
            conférences,un site de reservation de billets d’avions, application
            iOS pour la prévision de la metéo,la réalisation d’un mini projet
            arduino pour la souris 3D.
          </p>
          <a href='#contact' className='btn btn-primary'>
            Contact
          </a>
        </div>
      </div>
    </section>
  )
}

export default About
